export const APP_LOAD = "APP_LOAD";
export const ASYNC_START = "ASYNC_START";
export const ASYNC_END = "ASYNC_END";
export const REDIRECT = "REDIRECT";
export const CLEAR_REDIRECT = "CLEAR_REDIRECT";

export const CHECK_CAMPAIGN_ITEM = "CHECK_CAMPAIGN_ITEM";
export const CREATE_EVENT = "CREATE_EVENT";
export const LOCATE_PAGE_UNLOADED = "LOCATE_PAGE_UNLOADED";
